export class SonnerBaseEntity {

  getId(): any {
    return this["id"];
  }
}
